import withRestrictedRoute from '@pcid/components/restricted-route';
import CreateAccount from '../../containers/createAccount';

export default withRestrictedRoute(CreateAccount);
